export const API_KEY="AIzaSyAYLdQZLmQjGjcKUHmO8XPzLIQCtYb-Azs"

export default API_KEY